/**
 * Stable id for a remote picture URL.
 *
 * The same function exists in SQL (public.image_hash) and in the mirroring
 * edge function, so a URL always maps to the same storage folder no matter
 * which side computes it.
 */

const FNV_OFFSET = 0xcbf29ce484222325n;
const FNV_PRIME = 0x100000001b3n;
const MASK = 0xffffffffffffffffn;

/** Trim + un-escape the HTML entities some feeds store in query strings. */
export function normalizeImageUrl(url: string): string {
  return url.trim().replace(/&amp;/g, "&");
}

/** 64-bit FNV-1a of the normalized URL, lower-case hex, zero padded. */
export function imageHash(url: string): string {
  const bytes = new TextEncoder().encode(normalizeImageUrl(url));
  let hash = FNV_OFFSET;
  for (const byte of bytes) {
    hash ^= BigInt(byte);
    hash = (hash * FNV_PRIME) & MASK;
  }
  return hash.toString(16).padStart(16, "0");
}

/** Storage prefix for a picture: ab/cd/<hash>. */
export function imageBasePath(hash: string): string {
  return `${hash.slice(0, 2)}/${hash.slice(2, 4)}/${hash}`;
}
